module.exports = __webpack_public_path__ + "img/chevron-up.b9c151e1.svg";